// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"_10iC2","player":"_2nLLQ","thumbnail":"_3awp9","overlay":"_39jyi","button":"_7cBC_","arrow":"_1muwV","icon":"PhtHE"};